module.exports = __webpack_public_path__ + "img/serengeti-topout.c4937d04.jpg";